/*
  Рейка років на сторінці історії.

  Два завдання, обидва — про орієнтацію на довгій сторінці:
  1. Рейка липне під шапку теми, а не під верх в'юпорта. Висоту шапки не
     складаємо з частин, а міряємо фактичну — шапка буває фіксованою,
     липкою і звичайною, і в кожному випадку займає різне місце.
  2. Активний рік підсвічується за поточним розділом, а якір не заводить
     заголовок під рейку (scroll-margin-top).
*/
(function () {
  var root = document.querySelector('[data-bz-history]');
  if (!root) return;

  var rail = root.querySelector('.bzst-rail');
  var links = [].slice.call(root.querySelectorAll('.bzst-rail a'));
  var chapters = [].slice.call(root.querySelectorAll('[data-bz-chapter]'));

  /* Скільки зверху зайнято хромом теми. Міряємо нижню межу відносно в'юпорта,
     а не висоту: липка шапка теми ховається при скролі вниз (translateY -100%)
     і повертається при скролі вгору. Від'ємна межа = шапки на екрані немає,
     і рейка має стояти на самому верху. */
  function chromeBottom() {
    var bottom = 0;
    ['.wt-announcement', '.page-header', '.wt-header'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') return;
      bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
    });
    return Math.max(0, Math.round(bottom));
  }

  var lastTop = -1;

  function fit() {
    var top = chromeBottom();
    if (top === lastTop) return;
    lastTop = top;
    root.style.setProperty('--bzst-top', top + 'px');
    var railH = rail ? Math.round(rail.getBoundingClientRect().height) : 0;
    chapters.forEach(function (ch) {
      ch.style.scrollMarginTop = top + railH + 'px';
    });
  }

  /* Шапка їде трансформом 0.3s, тож одного заміру на подію скролу мало:
     тримаємо кадровий цикл, поки сторінка рухається, і ще трохи після. */
  var running = false;
  var until = 0;

  function loop() {
    fit();
    if (Date.now() < until) requestAnimationFrame(loop);
    else running = false;
  }

  function ping() {
    until = Date.now() + 500;
    if (running) return;
    running = true;
    requestAnimationFrame(loop);
  }

  // Після зміни ширини перерахунок потрібен навіть при тій самій межі:
  // висота самої рейки могла змінитися
  function refit() {
    lastTop = -1;
    ping();
  }

  fit();
  window.addEventListener('load', refit);
  window.addEventListener('scroll', ping, { passive: true });
  window.addEventListener('resize', refit, { passive: true });
  document.addEventListener('shopify:section:load', refit);

  if (!links.length || !chapters.length) return;

  function activate(id) {
    links.forEach(function (a) {
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('is-active', on);
      if (on) {
        a.setAttribute('aria-current', 'true');
        // Активний рік має бути видимим і тоді, коли рейка прокручена
        if (rail && a.offsetParent) {
          var box = rail.querySelector('.bzst-rail__in');
          if (box && box.scrollWidth > box.clientWidth) {
            var left = a.offsetLeft - (box.clientWidth - a.offsetWidth) / 2;
            box.scrollTo({ left: left, behavior: 'smooth' });
          }
        }
      } else {
        a.removeAttribute('aria-current');
      }
    });
  }

  if (!('IntersectionObserver' in window)) {
    activate(chapters[0].id);
    return;
  }

  /* Активним вважаємо розділ, чия верхня третина екрана зайнята: інакше при
     довгому розділі підсвітка перестрибує на наступний ще до його початку. */
  var seen = {};
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        seen[e.target.id] = e.isIntersecting;
      });
      for (var i = chapters.length - 1; i >= 0; i--) {
        if (seen[chapters[i].id]) {
          activate(chapters[i].id);
          return;
        }
      }
    },
    { rootMargin: '-18% 0px -62% 0px', threshold: 0 }
  );

  chapters.forEach(function (ch) { io.observe(ch); });
})();
